/* eslint-disable no-param-reassign */
import React, { PureComponent } from 'react';
import DatePicker from 'react-datepicker';
import MinusIcon from 'mdi-react/MinusIcon';
import store from '../../../containers/App/store'
import moment from 'moment'
import PropTypes from 'prop-types';

class IntervalDatePickerField extends PureComponent {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            startDate: moment(store.getState().stat.filters.date_from).toDate(),
            endDate:  moment(store.getState().stat.filters.date_to).toDate(),
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange({ startDate, endDate }) {
        startDate = startDate || this.state.startDate;
        endDate = endDate || this.state.endDate;

        if (moment(startDate).isAfter(endDate)) {
            endDate = startDate;
        }

        this.setState({ startDate, endDate });
        this.props.onChange({ start: startDate, end: endDate });
    }

    handleChangeStart = startDate => this.handleChange({ startDate });

    handleChangeEnd = endDate => this.handleChange({ endDate });

    render() {
        return (
            <div className="date-picker date-picker--interval">
                <DatePicker
                    selected={this.state.startDate}
                    selectsStart
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    onChange={this.handleChangeStart}
                    dateFormat="yyyy-MM-dd"
                    placeholderText="From"
                />
                <MinusIcon className="date-picker__svg" />
                <DatePicker
                    selected={this.state.endDate}
                    selectsEnd
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    onChange={this.handleChangeEnd}
                    dateFormat="yyyy-MM-dd"
                    placeholderText="To"
                />
            </div>
        );
    }
}

const renderIntervalDatePickerField = props => (
    <IntervalDatePickerField
        {...props.input}
    />
);

renderIntervalDatePickerField.propTypes = {
    input: PropTypes.shape({
        onChange: PropTypes.func,
    }).isRequired,
};

export default renderIntervalDatePickerField;
